import dateTimeToWords from './dateTimeToWords';

const formats: { [key: string]: any } = {
  short: {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  },
  natural: {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  },
  weekday: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  },
  verbose: {},
  ornate: {},
  verboseDateOnly: {},
  ornateDateOnly: {},
  hoursMinutes: {
    hour: 'numeric',
    minute: 'numeric',
  },
};
const wordyFormats = ['verbose', 'verboseDateOnly', 'ornate', 'ornateDateOnly'];
const localizedFormats = ['short', 'hoursMinutes'];
export const defaultFormat = 'natural';

export default function dateTimeFormatted(datetime?: Date | string | null, format = defaultFormat): string | null {
  if (!datetime) return null;

  let date;
  if (typeof datetime === 'string') {
    let dateString = datetime;
    if (dateString.match(/\d\d:\d\d:\d\d/)) {
      dateString = `${dateString} GMT`;
    }
    date = new Date(dateString);
  } else {
    date = datetime;
  }

  let formattedDate = '';
  const wordyFormat = wordyFormats.includes(format);
  if (!wordyFormat) {
    const options = {
      timeZone: 'UTC',
      ...formats[format],
    };
    const localizedFormat = localizedFormats.includes(format);
    const locale = localizedFormat ? undefined : 'en-US';

    formattedDate = date.toLocaleString(locale, options).replace(/\//g, '.');
  } else {
    const templates: { [key: string]: string } = {
      verbose: "%E, %M %d, %y at %HW%MW O'Clock",
      verboseDateOnly: '%E, %M %d, %y',
      ornate: "%E, %M %DOW, %YW at %HW%MW O'Clock %bw",
      ornateDateOnly: '%E, %M %DOW, %YW',
    };

    if (date instanceof Date && !isNaN(date.valueOf()) && isFinite(date.valueOf())) {
      formattedDate = dateTimeToWords(date, templates[format]);
    }
  }

  return formattedDate;
}
